import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'

enum ModelTypes {
  PatientWithExerciseSummary = 'patient-with-exercise-summary',
}

enum ModelTypeNames {
  PatientWithExerciseSummary = 'patientWithExerciseSummary',
}

export interface PatientExerciseSummaryAttributes {
  patientFirstName: string
  patientLastName: string
  numOfExercises: number
  avgCardioTimeMin: number
  avgEndHeartRateBpm: number
}

export interface PatientExerciseSummarySchema {
  id: string
  attributes: PatientExerciseSummaryAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithExerciseSummary]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        patientFirstName: { type: 'string' },
        patientLastName: { type: 'string' },
        numOfExercises: { type: 'number' },
        avgCardioTimeMin: { type: 'number' },
        avgEndHeartRateBpm: { type: 'number' },
      },
    },
  },
}

export async function getPatientWithExerciseSummarysQuery() {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient with exercise summary')
      return q.findRecords(ModelTypes.PatientWithExerciseSummary)
    })
    .catch(e => {
      console.log('fetch failed for patient with exercise summary')
      console.log(e)
    })
}
